import { createFirebaseBaseQueryWithReauth } from '@clareefai/api/rtk-query-firebase';

const baseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080/api';

export const baseQueryWithReauth = createFirebaseBaseQueryWithReauth({
  baseUrl,
  loginPath: '/login',
});
